import { Spinner } from '@v2/ui/Icon/Spinner/Spinner';
import { cn } from '@v2/utils';

interface Props {
  isLoading: boolean;
  onShowMoreClick: () => void;
  className?: string;
  label?: string;
}

export const ShowMoreButton = ({
  isLoading,
  onShowMoreClick,
  className,
  label = 'Show More',
}: Props) => {
  return (
    <button
      type="button"
      aria-disabled={isLoading}
      aria-busy={isLoading}
      aria-label={isLoading ? 'Loading more events' : label}
      onClick={() => {
        if (isLoading) return;
        onShowMoreClick();
      }}
      className={cn(
        'flex w-full items-center justify-center rounded-b-lg bg-gray-75 py-3 text-sm font-semibold text-gray-800 md:py-4 md:text-base',
        className
      )}
    >
      <span className="relative">
        <span
          aria-hidden="true"
          className="absolute inset-y-0 right-full mr-2 flex items-center"
        >
          {isLoading && <Spinner size="16" />}
        </span>
        {isLoading ? 'Loading more...' : label}
      </span>
    </button>
  );
};
